import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ChartCard } from '../../../charts/ChartCard'
import { StepLegend } from '../../../charts/Legend'
import { SegmentRowChart } from '../../../charts/SegmentRowChart'
import { SegmentRow } from '../../../charts/type'
import { getImpactSteps } from '../../../../utils/statistics/workImpact'
import { NotEnoughScreeningData } from '../../../charts/NotEnoughData'

type Props = {
  /** 1 to 3 rows: the API pools thin tiers. Empty when it suppressed the chart. */
  rows: readonly SegmentRow[]
}

export const ProductivityBySeverityCard = ({ rows }: Props) => {
  const { t } = useTranslation()
  const steps = useMemo(() => getImpactSteps(t), [t])
  const hasData = rows.length > 0

  return (
    <ChartCard
      title={t('admin.statistics.workImpactProductivityTitle')}
      caption={t('admin.statistics.workImpactProductivityCaption')}
      legend={hasData ? <StepLegend steps={steps} /> : undefined}
    >
      {hasData ? <SegmentRowChart steps={steps} rows={rows} unit="%" showUnitInline /> : <NotEnoughScreeningData />}
    </ChartCard>
  )
}
